import React, { createContext, useReducer } from "react";
import { SettingsReducer } from "./SettingsReducer";
import { MODAL_RESET } from "../SettingsConstant";

export const SettingsContext = createContext();

export const SettingsContextProvider = (props) => {
  const settingsInsight = {
    settingsData: {
      flowData: {
        WIP_TARGET: "70",
        STOW_WIP_UPPER: "30",
        STOW_WIP_LOWER: "15",
      },
      indirectHCData: {
        // stationCode: "DWA2",
        processRules: {
          // "DIVERTER": {
          //     ruleType: "Fixed HC",
          //     minAssociates: "2"
          // },
          // "WATER_SPIDER": {
          //     ruleType: "Ratio",
          //     minAssociates: "1",
          //     ratioToAssociatedProcess: "3",
          //     associatedProcess: "INDUCT"
          // },
          // "INDUCT": {
          //     ruleType: "Volume",
          //     minAssociates: "2",
          //     volume: "10000"
          // }
        },
      },
      roster: {},
      schedule: {},
      showUpdatePlanResponseModal: MODAL_RESET,
      messageToDisplay: null,
      //Delete Rule Modal
      openDeleteIndirectHCRuleModal: false,
      indirectHCRuleToDelete: null,
    },
    messageToDisplay: null,
    opsClockData: {},
    opsClockErrors: [],
    opsClockDirtyPairs: [],
    breaksData: {},
    currentOpsClockDate: null,
    currentBreaksDate: null,
    showUpdatePlanResponseModal: MODAL_RESET,
    allCycles: [],
    resetTime: {},
    deleteBreakData: {
      openDeleteBreakModal: false,
      indexOfTheBreakToDelete: null,
    },
  };

  const [viewModel, dispatch] = useReducer(SettingsReducer, settingsInsight);

  return (
    <SettingsContext.Provider value={{ viewModel, dispatch }}>
      {props.children}
    </SettingsContext.Provider>
  );
};

export default SettingsContextProvider;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsContext.js